var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConclude({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 36 36",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.46 2.81c-.08-.19-.26-.31-.46-.31h-22.5v-1.5c0-.28-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5v34c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-15.5h22.5c.2 0 .38-.12.46-.31s.03-.4-.11-.54l-7.64-7.65 7.65-7.65c.14-.14.18-.35.1-.54zm-23.96 31.69h-2v-33h2zm15.15-23.85c-.2.2-.2.51 0 .71l7.15 7.15h-21.3v-15h21.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConclude);
export default __webpack_public_path__ + "static/media/conclude.46436b0598a2515ec4bbaecf40e7d0ce.svg";
export { ForwardRef as ReactComponent };